import { ORGANIZATION_TYPE_CODING_MAP } from '@bariendo/lib/codings';
import { OrganizationType } from '@bariendo/lib/constants';
import { Pill } from '@mantine/core';

const partnerTypeToColor: Record<OrganizationType, { text: string; bg: string }> = {
  [OrganizationType.FACILITY]: {
    text: '#193cb8',
    bg: '#dbeafe',
  },
  [OrganizationType.PHARMACY]: {
    text: '#016630',
    bg: '#dcfce7',
  },
  [OrganizationType.LABORATORY]: {
    text: '#6e11b0',
    bg: '#f3e8ff',
  },
  [OrganizationType.SUPPLIER]: {
    text: '#9f2d1d',
    bg: '#ffedd4',
  },
  [OrganizationType.INSURANCE]: {
    text: '#372aac',
    bg: '#e0e7ff',
  },
  [OrganizationType.EXTERNAL_PROVIDER]: {
    text: '#005f5a',
    bg: '#cbfbf1',
  },
  [OrganizationType.IV_HYDRATION_PARTNER]: {
    text: '#7b341e',
    bg: '#fef3c7',
  },
  [OrganizationType.ANESTHESIA]: {
    text: '#9f1239',
    bg: '#ffe4e6',
  },
};

function isSupportedPartnerType(type: OrganizationType): boolean {
  // Exclude Medplum's sandbox resources
  return (
    !!type &&
    Object.keys(partnerTypeToColor).includes(type) &&
    !!partnerTypeToColor[type] &&
    !!ORGANIZATION_TYPE_CODING_MAP[type]
  );
}

export function PartnerTypePill({ type }: { type: OrganizationType }) {
  if (!isSupportedPartnerType(type)) return null;
  return (
    <Pill c={partnerTypeToColor[type].text} size="xs" bg={partnerTypeToColor[type].bg}>
      {ORGANIZATION_TYPE_CODING_MAP[type]?.display}
    </Pill>
  );
}
